<template>
  <div class="application">
    <h1>爱股票合作者服务规范</h1>
    <p v-html="content.replace(/\n/gi, '<br />')"></p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content:`一、总则
1.1、为维护爱股票社区平台以及平台内所有产品秩序,保障平台内所有产品合作者的合法权益,根据社区合作者协议,拟制本规范。
1.2、为享有平台内所有产品各项正当权益,产品合作者(以下称"合作者")应当同意本规范全部条款并完成注册程序,成为平台内所有产品的正式合作者,享有合作者权益,承担平台内所有产品义务。
二、合作者的基本权利和义务
2.1、合作者应遵循的规范和义务、
1.合作者应当对其合作者帐号进行的所有活动和事件负法律责任;
2.合作者应遵守中华人民共和国法律、法规,自行承担一切可能因产品平台内所有产品活动直接或间接引起的法律责任;
3.合作者应当遵守社区视频产品平台内所有产品的各项规章制度;
4.合作者有义务遵守网络礼仪。
2.2、合作者帐号和密码由合作者负责保管;合作者不应将其帐号、密码转让或出借予他人使用。如合作者发现其帐号遭他人非法使用,应立即通知爱股票社区。因非法行为或合作者的保管疏忽导致帐号、密码遭他人非法使用,爱股票社区不承担任何责任。
2.3、合作者有在平台内对个人所有产品发布观点和回复问题的权限,若有特殊规范,或合作者因受到处罚而关闭权限则例外。
2.4、合作者认为自己在产品平台内个人所有产品的权益受到侵害,有权根据相关规范进行投诉申诉。
2.5、合作者享有寻求爱股票社区其他业务支持与帮助的权利。
2.6、合作者在使用产品平台服务过程中,必须遵循以下原则:
1.遵守中国有关的法律和法规;
2.遵守所有与网络服务有关的网络协议、规范和程序;
3.遵守产品平台内的管理规范以及其他规范;
4.不得为任何非法目的而使用产品平台的产品服务;
5.不得利用产品平台内的产品服务进行任何可能对互联网或移动网正常运转造成不利影响的行为;
6.不得利用产品平台服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料;
7.合作者不得利用该平台进行散布虚假信息、操纵市场、欺骗用户等不合法行为。
8.合作者不得在平台内产品讲授过程中留联系方式,包括但不限于电话、论坛、网站网址等。
9.不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益;
10.不得利用产品平台服务进行任何不利于爱股票社区产品平台内所有产品的行为;
11.如发现任何非法使用合作者帐号或帐号出现安全漏洞的情况,应立即通告爱股票社区产品平台;
12.禁止未经爱股票社区产品平台允许发布广告; 　
13.严禁发表与产品平台内宗旨无关主题、与主题无关回复、上传与内容无关图; 　
14.禁止利用bug扰乱产品平台内产品秩序;
15.严禁破坏产品平台内产品公共秩序及侵害爱股票社区利益的其它行为; 　
16.爱股票社区对平台内所有产品保留所有发布内容的最终操作权。
2.7、如合作者在使用爱股票社区产品平台时违反任何上述规范,其授权的人有权要求合作者改正或直接采取一切必要的措施(包括但不限于更改或删除合作者发布的内容等、暂停或终止合作者使用产品平台内所有产品服务的权利)以减轻合作者不当行为造成的影响。
三、ID管理和产品平台内所有产品与发布规则
3.1、凡合作者ID中出现如下信息者,产品平台内所有产品有权予以收回或注销、
1.以党和国家领导人或其他名人的真实姓名、字号、艺名、笔名、头衔注册;
2.以国家机构或其他机构的名称注册;
3.性别歧视、种族歧视、;
4.个人侮辱、自侮辱、猥亵;
5.易产生歧义、引起他人误解信息;
6.其它法律法规以及产品平台内所有产品规范的禁止规则中包含的信息。
3.2、产品平台内注册之日起两年未登陆ID,产品平台内所有产品有权收回。
3.3、合作者不得利用本站制作、复制和传播下列信息、
1.违反中华人民共和国宪法以及其它法律、法规的;危害国家安全,泄露国家秘密,颠覆国家政权,破坏国家统一的;损害国家荣誉和利益的;煽动民族仇恨、民族歧视,破坏民族团结的; 　
5.破坏国家宗教政策,宣扬邪教和封建迷信的; 　
6.散布谣言,扰乱社会秩序,破坏社会稳定的; 　
7.散布淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的; 　
8.侮辱或者诽谤他人,侵害他人合法权益的; 　
9.含有法律、行政法规禁止的其他内容的;
10.辱骂、人身攻击的; 　
11.非经爱股票社区批准授权的任何形式的广告; 　
12.病毒代码及其它攻击性程序代码;
13.其它扰乱产品平台内产品言论秩序的内容。
3.4、凡上述信息产品平台有权删除屏蔽;凡违反规范发布上述信息者,产品平台视情节轻重有权对其进行封ID、注销ID、封IP等处理,直至交由相关部门追究法律责任。
3.5、ID管理和产品平台产品与发布规则未尽事宜参照相关规范。
四、隐私权保护
4.1、保护合作者隐私;爱股票社区保证不对外公开或向第三方提供单个合作者的注册资料及合作者在使用网络服务时存储在爱股票社区的非公开内容,但下列情况除外、
1.事先获得合作者的明确授权;
2.根据有关的法律法规要求;
3.按照相关司法部门的要求;
4.为维护社会公众的利益;
5.为维护爱股票社区的合法权益。
4.2、爱股票社区可能会与第三方合作向合作者提供相关的网络服务,在此情况下,如该第三方同意承担与爱股票社区同等的保护合作者隐私的责任,则爱股票社区有权将合作者的注册资料等提供给该第三方。
4.3、在不透露单个合作者隐私资料的前提下,产品平台内所有产品有权对整个合作者数据库进行分析并对合作者数据库进行商业上的使用。
五、版权申明
5.1、爱股票社区平台内所有注册合作者观点均不代表爱股票社区以及爱股票社区立场,仅代表作者本人观点。
5.2、产品平台内所有产品资料版权仅归原作者所有,产品平台拥有产品有权将发布的信息用于其他用途,包括但不限于网站、电子期刊、平面出版等,文章有附带版权声明者除外。
5.3、合作者转贴应注明原始出处和时间,并负担由此可能产生的版权责任;
5.4、产品平台内所有产品根据版面管理需要有权删除修改;
5.5、任何转载、引用发表于产品平台内所有产品的版权文章、图片及其它作品须符合以下规范、
1.用于非商业、非盈利、非广告性目的时需注明作者及出处为“爱股票社区产品平台产品”。
2.用于商业、盈利、广告性目的时需征得文章、图片以及其它作品的原作者的同意,不得未经作者同意而剽窃、引用产品平台内所有产品的任何版权作品。
3.任何文章、图片以及其它作品的修改或删除均应保持作者原意并征求原作者同意,并注明授权范围。
六、免责声明
6.1、合作者明确同意其使用产品平台服务所存在的风险将完全由其自己承担;因其使用产品平台而产生的一切后果也由其自己承担,爱股票社区以及产品平台对合作者不承担任何责任。
6.2、产品平台不担保产品平台内所有产品服务一定能满足合作者的要求,也不担保产品平台内所有产品服务不会中断,对产品平台内所有产品服务的及时性、安全性、准确性也都不作担保。
6.4、合作者之间通过产品平台内所有产品相识、交往中所发生或可能发生的任何心理、生理上的伤害和经济上的纠纷与损失,爱股票社区不承担任何责任。
6.5、对于因不可抗力或产品平台内所有产品不能控制的原因造成的服务中断或其它缺陷,产品平台内所有产品不承担任何责任,但将尽力减少因此而给合作者造成的损失和影响。
七、附则
7.1、产品平台内所有产品有权根据产品平台内本规范进行修订。
7.2、爱股票社区享有本规范的最终解释权。
7.3、本规范自发布之日起生效。
      `
    }
  }
}

</script>
<style lang="scss" scoped>
    .application{
        min-height: calc(100vh - 195px);
        margin: 10px auto 0;
        background: #fff;
        
        >h1{
            color: #f45336;
            font-size: 24px;
            line-height: 36px;
            font-weight: 700;
            border-bottom: 2px solid #f45336;
            padding-bottom: 15px;
            text-align: center;
        }
        >p{
            font-size: 16px;
            line-height: 1.6;
            padding: 20px 10px;

        }
    }
</style>